import { roundToTen } from "src/util";
import { IChartPoint } from "../../types";

export const createChartPoint = (
  coachAverage: number,
  studentAverage: number,
  date: string,
  sportId: number
): IChartPoint => ({
  teacher: parseFloat(roundToTen(coachAverage)),
  date,
  sportId,
  student: parseFloat(roundToTen(studentAverage)),
});



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/hooks/utils/createChartPoint/createChartPoint.ts